<template>
  <div>
    <el-form class="demo-ruleForm">
      <el-form-item class="query-form-item">
        <el-select
          v-model="querySearch"
          filterable
          remote
          clearable
          reserve-keyword
          class="query-select"
          :placeholder="selectPlaceholder"
          :remote-method="remoteMethod"
          :loading="loading"
          :disabled="disabled"
          @change="handleChange"
        >
          <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <slot class="extra-item" name="extra"></slot>
      </el-form-item>
      <el-form-item>
        <div class="cc-select-panel">
          <div class="cc-select-panel-left">
            <div class="cc-select-panel-left-module" :style="{width: 100/currColumn + '%'}" style="min-width: 100px;">
              <div class="cc-select-panel-module">
                <div class="cc-select-panel-module-header">
                  <span class="cc-select-panel-module-header-title">{{menu[0]}}</span>
                </div>
                <div :class="[disabled?'cc-select-panel-disabled':'']" class="cc-select-panel-module-container">
                  <template v-if="!onlySelectLeaf">
                    <div class="cc-select-panel-item">
                      <span class="cc-select-panel-item-checkbox">
                        <el-checkbox
                          :value="getSelectStatus(rootNode) === 1"
                          :indeterminate="getSelectStatus(rootNode) === 2"
                          @input="selectAll(rootNode)"
                          :disabled="disabled"
                        ></el-checkbox>
                      </span>
                      <span class="cc-select-panel-item-name">全选</span>
                    </div>
                  </template>
                  <div v-for="(item,index) in leftData" :key="'l'+index" class="cc-select-panel-item" @click="firstSelect(item)">
                    <span v-if="!onlySelectLeaf" class="cc-select-panel-item-checkbox">
                      <el-checkbox
                        :value="getSelectStatus(item)=== 1"
                        :indeterminate="getSelectStatus(item) === 2"
                        @input="handleToggleSelectNode(item)"
                        :disabled="disabled"
                      ></el-checkbox>
                    </span>
                    <span class="cc-select-panel-item-name">{{item.label}}</span>
                    <span v-if="item.hasOwnProperty('children')" class="cc-select-panel-item-toright">
                      <i class="el-icon-arrow-right"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="Object.keys(secondData).length>0"
              class="cc-select-panel-left-module"
              :style="{width: 100/currColumn + '%'}"
              style="min-width: 100px;"
            >
              <div class="cc-select-panel-module">
                <div class="cc-select-panel-module-header">
                  <span class="cc-select-panel-module-header-title">{{menu[1]}}</span>
                </div>
                <div :class="[disabled?'cc-select-panel-disabled':'']" class="cc-select-panel-module-container">
                  <div class="cc-select-panel-item cc-select-panel-item-check" @click="selectAll(secondData)">
                    <span class="cc-select-panel-item-checkbox">
                      <el-checkbox
                        :value="getSelectStatus(secondData)=== 1"
                        :indeterminate="getSelectStatus(secondData) === 2"
                        @input="handleToggleSelectNode(secondData)"
                        :disabled="disabled"
                      ></el-checkbox>
                    </span>
                    <span class="cc-select-panel-item-name">全选</span>
                  </div>
                  <div
                    v-for="(item,index) in secondData[this.childKey]"
                    :key="'s'+index"
                    @click="secondSelect(item)"
                    class="cc-select-panel-item cc-select-panel-item-check"
                  >
                    <span class="cc-select-panel-item-checkbox">
                      <el-checkbox
                        :value="getSelectStatus(item) === 1"
                        @input="handleToggleSelectNode(item)"
                        :indeterminate="getSelectStatus(item) === 2"
                        :disabled="disabled"
                      ></el-checkbox>
                    </span>
                    <span class="cc-select-panel-item-name">{{item.label}}</span>
                    <span v-if="item.hasOwnProperty('children')" class="cc-select-panel-item-toright">
                      <i class="el-icon-arrow-right"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cc-select-panel-right">
            <div class="cc-select-panel-module">
              <div class="cc-select-panel-module-header">
                <span class="cc-select-panel-module-header-title">已选({{selected.length}})</span>
                <template v-if="reverse">
                  <span class="cc-select-panel-item-checkbox">
                    <el-checkbox @input="selectReverse(rootNode)" style="display:inline;margin-right: 6px;" :disabled="disabled"></el-checkbox>
                    <span class="cc-select-panel-item-name" style="display:inline">反选</span>
                  </span>
                </template>
                <span class="cc-select-panel-module-header-clear-disabled" v-if="disabled">清空</span>
                <span class="cc-select-panel-module-header-clear" @click="cleanSelectItem" v-else>清空</span>
              </div>
              <div :class="[disabled?'cc-select-panel-disabled':'']" class="cc-select-panel-module-container">
                <el-tag
                  class="region-input-item"
                  v-for="(item,index) in selected"
                  :key="'r'+index"
                  :closable="!disabled"
                  @close="selectRemove(item)"
                >{{item.label}}</el-tag>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    columns: { type: Array, default: () => ['省份', '城市'] },
    leftData: {
      type: Array,
      default: () => [
        { label: '北京市', value: '11' },
        { label: '上海市', value: '21' },
        {
          label: '广东省',
          value: '51',
          children: [
            { label: '深圳市', value: '5181100' },
            { label: '惠州市', value: '5181101' }
          ]
        },
        {
          label: '广西省',
          value: '41',
          children: [{ label: '南宁市', value: '4181100' }]
        }
      ]
    },
    rightData: { type: Array, default: () => [] },
    // values: { type: Array, default: () => [] },
    onlySelectLeaf: { type: Boolean, default: false }, // 是否只能选择叶子节点
    disabled: { type: Boolean, default: false },
    selectPlaceholder: { type: String, default: '请输入关键词' },
    reverse: { type: Boolean, default: false }
  },
  data() {
    return {
      querySearch: '',
      loading: false,
      options: [],
      childKey: 'children',
      menu: this.columns,
      // leftData: this.data,
      secondData: {}, // 第二列数据
      thirdData: {}, // 第三列数据
      // selectValues: this.values,
      // selectRightData: this.rightData,
      currColumn: 1, // 当前列数，
      isSelectAll: false, // 是否选择一级所有
      isSecondSelectAll: false, // 是否选择了二级所有
      isThirdSelectAll: false, // 是否选择了三级所有
      selected: this.rightData,
      keyWords: undefined,
      parentCache: null,
      selectStatusIndexed: null,
      SELECT_STATUS: {
        UNSELECTED: 0,
        SELECTED: 1,
        INDETERMINATE: 2
      }
    }
  },
  watch: {
    // selected: {
    //   handler(newValue, oldValue) {
    //     this.$emit('selectValues', newValue)
    //   },
    //   deep: true
    // }
    rightData: {
      handler(newValue, oldValue) {
        if (this.selected !== newValue) {
          if (newValue.length === 0) {
            this.selected.forEach(item => this.handleCancelSelectNode(item, false))
          } else {
            this.selected.forEach(item => this.handleCancelSelectNode(item, false))
            newValue.forEach(item => this.handleSelectNode(item, false))
          }
        }
      }
    }
  },
  computed: {
    rootNode() {
      return {
        value: null,
        children: this.leftData
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$watch(
        'leftData',
        () => {
          this.setCacheAndStatus()
          this.selected = [] // 清空选中
          this.rightData.forEach(item => this.handleSelectNode(item, false))
        },
        { immediate: true }
      )
    },
    // 一级选择
    firstSelect(item) {
      if (item.hasOwnProperty(this.childKey)) {
        this.currColumn = 2
        this.secondData = item
      } else {
        this.secondData = {}
        this.currColumn = 1
      }
    },
    // 二级选择
    secondSelect(item) {
      if (item.hasOwnProperty(this.childKey)) {
        this.currColumn = 3
        this.thirdData = item
      } else {
        this.thirdData = {}
        this.currColumn = 2
      }
    },
    // 三级选择
    thirdSelect(item) {},
    // 一级选择全部
    selectAll(data) {
      const rootNode = this.rootNode
      if (data === rootNode) {
        const { SELECT_STATUS, selectStatusIndexed } = this
        const status = this.getSelectStatus(rootNode)
        if (status === SELECT_STATUS.INDETERMINATE) {
          // 把没选中的选中
          rootNode.children.filter(child => selectStatusIndexed[child.value] !== SELECT_STATUS.SELECTED).forEach(this.handleSelectNode)
        } else {
          // 切换选中状态
          rootNode.children.forEach(this.handleToggleSelectNode)
        }
      } else {
        this.handleToggleSelectNode(data)
      }
    },
    // 反选
    selectReverse(data) {
      const { SELECT_STATUS, selectStatusIndexed } = this
      data.children.forEach(item => {
        const status = selectStatusIndexed[item.value]
        if (item.children && status === SELECT_STATUS.INDETERMINATE) {
          item.children.forEach(this.handleToggleSelectNode)
        } else {
          this.handleToggleSelectNode(item)
        }
      })
    },
    // 删除按钮
    selectRemove(item) {
      this.handleCancelSelectNode(item)
    },
    // 清空所有选中的值
    cleanSelectItem() {
      this.selected.forEach(item => {
        this.handleCancelSelectNode(item)
      })
    },
    getSelectStatus(item) {
      const { rootNode, selectStatusIndexed, SELECT_STATUS } = this
      if (item === rootNode) {
        const children = item.children
        const hasUnSelected = children.some(child => selectStatusIndexed[child.value] === SELECT_STATUS.UNSELECTED)
        const hasSelected = children.some(child => {
          const status = selectStatusIndexed[child.value]
          return status === SELECT_STATUS.SELECTED || status === SELECT_STATUS.INDETERMINATE
        })
        if (hasUnSelected && !hasSelected) {
          return SELECT_STATUS.UNSELECTED
        }
        if (!hasUnSelected && hasSelected) {
          return SELECT_STATUS.SELECTED
        }
        if (hasUnSelected && hasSelected) {
          return SELECT_STATUS.INDETERMINATE
        }
      }
      return this.selectStatusIndexed[item.value]
    },
    isSelected(item) {
      const { SELECT_STATUS, selectStatusIndexed } = this
      const status = selectStatusIndexed[item.value]
      return status === SELECT_STATUS.SELECTED
    },
    handleToggleSelectNode(item) {
      if (this.isSelected(item)) {
        this.handleCancelSelectNode(item)
      } else {
        this.handleSelectNode(item)
      }
    },
    handleSelectNode(item, emit = true) {
      // 取消选中所有后代
      const children = item.children || []
      children.forEach(this.doCancelSelectNode)
      // 把当前节点放到选中列表里
      this.doSelectNode(item)
      const parent = this.getParent(item)
      if (parent) {
        if (this.isChildrenSelected(parent)) {
          this.handleSelectNode(parent, emit)
        }
      }
      this.selected = this.selected.slice()
      if (emit) {
        this.$emit('selectValues', this.selected)
      }
    },
    handleCancelSelectNode(item, emit = true) {
      const isOwnSelected = this.selected.some(({ value }) => item.value === value)
      if (isOwnSelected) {
        this.doCancelSelectNode(item)
      } else {
        // 祖先被选中
        const parent = this.getParent(item)
        if (parent) {
          this.handleCancelSelectNode(parent, emit)
          parent.children.forEach(child => {
            if (child.value !== item.value) {
              this.doSelectNode(child)
            }
          })
        }
      }
      this.selected = this.selected.slice()
      if (emit) {
        this.$emit('selectValues', this.selected)
      }
    },
    setSelectedStatus(item, status) {
      const { SELECT_STATUS, selectStatusIndexed } = this
      if (status === SELECT_STATUS.SELECTED) {
        // 把当前节点的子节点状态设为选中
        this.updateDownSelectedStatus(item, status)
        // 把当前节点设为 选中
        selectStatusIndexed[item.value] = SELECT_STATUS.SELECTED
        // 把当前节点的父节点的状态设为部分选中
        // 不用担心部分选中的状态不正确，假设所有的子都被选中，它会自动被设为选中状态
        const parent = this.getParent(item)
        if (parent) {
          this.updateUpSelectedStatus(parent, SELECT_STATUS.INDETERMINATE)
        }
        return
      }

      if (status === SELECT_STATUS.UNSELECTED) {
        // 把当前节点的子节点状态设为没选中
        this.updateDownSelectedStatus(item, status)
        // 把当前节点设为没选中
        selectStatusIndexed[item.value] = SELECT_STATUS.UNSELECTED
        const parent = this.getParent(item)
        if (parent) {
          this.updateUpSelectedStatus(parent, SELECT_STATUS.UNSELECTED)
        }
      }
    },
    updateUpSelectedStatus(item, status) {
      // 递归更新祖先节点状态
      const { SELECT_STATUS, selectStatusIndexed } = this
      if (status === SELECT_STATUS.UNSELECTED) {
        // 如果是取消选中, 先看看还有没有子节点被选中
        const hasChildSelected = item.children.some(child => selectStatusIndexed[child.value] !== SELECT_STATUS.UNSELECTED)
        if (hasChildSelected) {
          selectStatusIndexed[item.value] = SELECT_STATUS.INDETERMINATE
        } else {
          selectStatusIndexed[item.value] = SELECT_STATUS.UNSELECTED
        }
      } else {
        selectStatusIndexed[item.value] = status
      }
      const parent = this.getParent(item)
      if (parent) {
        this.updateUpSelectedStatus(parent, status)
      }
    },
    updateDownSelectedStatus(item, status) {
      // 递归的更新后代节点的状态
      const { selectStatusIndexed } = this
      const children = item.children || []
      children.forEach(child => {
        selectStatusIndexed[child.value] = status
        this.updateDownSelectedStatus(child, status)
      })
    },
    doSelectNode(item) {
      const { selected, SELECT_STATUS } = this
      const isExist = selected.some(e => e.value === item.value)
      if (!isExist) {
        selected.push(item)
      }
      this.setSelectedStatus(item, SELECT_STATUS.SELECTED)
    },
    doCancelSelectNode(item) {
      const { selected, SELECT_STATUS } = this
      this.selected = selected.filter(({ value }) => value !== item.value)
      // 递归删除所有后代节点
      const children = item.children || []
      children.forEach(this.doCancelSelectNode)
      this.setSelectedStatus(item, SELECT_STATUS.UNSELECTED)
    },
    isChildrenSelected(item) {
      const selectedIndexed = this.selected.reduce((result, item) => {
        result[item.value] = true
        return result
      }, {})
      const isAllSelected = item.children.every(item => selectedIndexed[item.value])
      return isAllSelected
    },
    getParent(item) {
      const rootNode = this.rootNode
      const parent = this.parentCache[item.value]
      const result = parent ? (parent === rootNode ? null : parent) : null
      return result
    },
    handlSearch(value) {
      const list = this.rootNode
      if (list.children) {
        this.handleFind(list, value)
      }
    },
    handleFind(arr, searchValue) {
      const nodeIndexedByKey = {}
      const setIndex = nodeList => {
        nodeList.forEach(item => {
          nodeIndexedByKey[item.label] = item
          if (item.children) {
            setIndex(item.children)
          }
        })
      }
      setIndex(arr.children)
      if (nodeIndexedByKey[searchValue]) {
        if (this.isSelected(nodeIndexedByKey[searchValue])) {
        } else {
          this.handleToggleSelectNode(nodeIndexedByKey[searchValue])
        }
      } else {
        this.notFindKey.push(searchValue)
      }
    },
    setCacheAndStatus() {
      const { SELECT_STATUS } = this
      const parentCache = {}
      const selectStatusIndexed = {}
      const walk = nodeList => {
        if (nodeList.length === 0) {
          return
        }
        const nextList = []
        nodeList.forEach(parent => {
          const children = parent.children
          if (children) {
            children.forEach(child => {
              nextList.push(child)
              parentCache[child.value] = parent
              selectStatusIndexed[child.value] = SELECT_STATUS.UNSELECTED
            })
          }
        })
        return walk(nextList)
      }
      walk([this.rootNode])
      this.parentCache = parentCache
      this.selectStatusIndexed = selectStatusIndexed
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options = []
          let originOptions = JSON.parse(JSON.stringify(this.leftData || []))
          originOptions.forEach(element => {
            if (element.label.includes(query)) {
              this.options.push({
                value: element.value,
                label: element.label,
                children: element.children
              })
            } else {
              (element.children || []).forEach(item => {
                if (item.label.includes(query)) {
                  this.options.push({
                    value: item.value,
                    label: item.label
                  })
                }
              })
            }
          })
        }, 200)
      } else {
        this.options = []
      }
    },
    handleChange() {
      const data = this.options
        .filter(({ value }) => value === this.querySearch)
        .reduce((result, item) => {
          result = item
          return result
        }, {})
      this.handleToggleSelectNode(data)
      this.querySearch = ''
      this.options = []
    }
  },
  name: 'cc-select-panel'
}
</script>

<style lang="stylus" scoped>
.cc-select-panel
  display flex
  min-height 160px
.cc-select-panel-left
  flex 1
  margin-right 16px
  width 300px !important
.cc-select-panel-left-module
  width 100%
  min-width 180px
.cc-select-panel .cc-select-panel-left
  position relative
  display inline-flex
  vertical-align top
.cc-select-panel .cc-select-panel-left-module
  display inline-block
  -webkit-box-flex 0
  -ms-flex none
  flex none
.cc-select-panel
  .cc-select-panel-left-module:first-child:not(:last-child), .cc-select-panel-module
    border-top-right-radius 0
    border-bottom-right-radius 0
  .cc-select-panel .cc-select-panel-left-module:not(:first-child)
    margin-left -1px
  .cc-select-panel-module
    width 100%
    background-color #fff
    border 1px solid #DCDFE6
    border-radius 3px
    overflow hidden
  .cc-select-panel-module-header
    border-bottom 1px solid #DCDFE6
    color #606266
    font-size 14px
    line-height 20px
    padding 8px 10px
    display flex
    justify-content space-between
  .cc-select-panel-module-container
    height 192px
    padding 6px 0
    overflow-y auto
    position relative
  .cc-select-panel-right
    flex 0 0 200px
  .cc-select-panel-item
    padding 0px 12px
    cursor pointer
    display flex
    flex-direction row
    align-items center
  .cc-select-panel-item:hover
    background #f2f2f2
  .cc-select-panel-item-checkbox
    margin-right 6px
  .cc-select-panel-item-name
    display block
    cursor pointer
    white-space nowrap
    text-overflow ellipsis
    overflow hidden
    line-height 22px
    font-size 14px
    color #606266
    font-weight 400
  /* * 选中样式 * */
  .cc-select-panel-item-active .cc-select-panel-item-name
    color #f78400
  .cc-select-panel-item-active
    .cc-select-panel-item-toright, .el-icon-arrow-right
      color #f78400
  .cc-select-panel-item-toright
    position absolute
    right 12px
    cursor pointer
  .cc-select-panel-item-remove:first-child
    margin-top 6px
  .cc-select-panel-item-remove
    margin 8px 12px
    padding 2px 8px
    background-color #f2f2f2
    border-radius 4px
    position relative
  .cc-select-panel-item-remove .cc-select-panel-item-close
    position absolute
    right 8px
    top 3px
    line-height 18px
    cursor pointer
  .cc-select-panel-module-header .cc-select-panel-module-header-clear
    flex-shrink 0
    color #ff8b00
    cursor pointer
    margin-left 12px
  .cc-select-panel-module-header-clear-disabled
    flex-shrink 0
    color #999
    cursor not-allowed
    margin-left 12px
  .cc-select-panel-disabled .cc-select-panel-item-check
    pointer-events none
  .cc-select-panel-disabled .cc-select-panel-item-name
    color #999
    cursor not-allowed
  .cc-select-panel-disabled .k-checkbox.k-checked .k-wrapper, .cc-select-panel-disabled .k-checkbox.k-indeterminate .k-wrapper
    border-color #999
    background #999
  .cc-select-panel-disabled
    .cc-select-panel-item-remove, .cc-select-panel-item-close
      display none
  >>>.el-tag
    width 95%
    display flex
    flex-direction row
    justify-content space-between
    align-items center
    margin 5px
.query-form-item >>> .el-form-item__content
  display flex
  flex-flow row nowrap
  .query-select
    width calc(100% - 216px)
.mg-left
  margin-left 20px
</style>
